import React from "react";
import { TbBrandTelegram } from "react-icons/tb";
import { FiGithub } from "react-icons/fi";
import { FiLinkedin } from "react-icons/fi";
import "../styles/sticky.scss";
export default function Sticky() {
  return (
    <>
      <div className="sticky-social-icons">
        {/* <a target="blank" href="https://www.facebook.com/creativeabod">
          <RiFacebookCircleLine className="social-icons" />
        </a> */}
        <a target="blank" href="https://t.me/Capit_sofis">
          <TbBrandTelegram className="social-icons" />
        </a>
        <a
          target="blank"
          href="https://linkedin.com/in/sofoniyas-alemu?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BUAC5npkgRz2jh7Nowj%2B20w%3D%3D"
        >
          <FiLinkedin className="social-icons" />
        </a>
        <a target="blank" href="https://github.com/capit-sofi">
          <FiGithub className="social-icons" />
        </a>
        <div className="social-line"></div>
      </div>
    </>
  );
}
